{
  "nav": {
    "home": "Főoldal",
    "mobileHomes": "Mobilházak",
    "products": "Egyéb termékek",
    "about": "Rólunk",
    "contact": "Kapcsolat",
    "blog": "Blog",
    "enquire": "Érdeklődjön most",
    "openMenu": "Menü megnyitása",
    "closeMenu": "Menü bezárása"
  },
  "common": {
    "readMore": "Tovább",
    "submit": "Küldés",
    "cancel": "Mégse",
    "loading": "Betöltés...",
    "error": "Hiba történt",
    "success": "Sikeres",
    "search": "Keresés",
    "title": "Fordítási példa",
    "examples": "Fordítási példák",
    "key": "Kulcs",
    "translation": "Fordítás",
    "currentLanguage": "Jelenlegi nyelv"
  },
  "contact": {
    "loading": "Kapcsolati információk betöltése...",
    "title": "Kapcsolat",
    "intro": "Van egy projektje? Küldjön nekünk egy érdeklődést, és felvesszük Önnel a kapcsolatot.",
    "enquireNow": "Érdeklődjön most",
    "generalEnquiries": "Általános érdeklődések",
    "salesEnquiries": "Értékesítési érdeklődések",
    "followUs": "Kövessen minket",
    "ourOffice": "Irodánk",
    "viewMap": "Térkép megtekintése",
    "ourFactory": "Gyárunk",
    "address": {
      "full": "Temes u. 18, 3528 Miskolc, HUNGARY",
      "label": "Cím"
    },
    "phone": {
      "number": "(+381) 69 220 7072",
      "label": "Telefon"
    },
    "officeDescription": "Széleskörű tapasztalattal a vendéglátás és ügyfélszolgálat terén, csapatunk elkötelezett amellett, hogy zökkenőmentes élményt nyújtson az elejétől a végéig.",
    "factoryDescription": "Miskolci kapcsolat HUB-ban található gyárunk a legújabb gyártási technológiával van felszerelve, hogy kiváló minőségű moduláris otthonokat és szerkezeteket szállítson.",
    "name": "Név",
    "email": "E-mail",
    "message": "Üzenet",
    "formPhone": "Telefon",
    "formAddress": "Cím",
    "send": "Üzenet küldése"
  },
  "enquiry": {
    "formTitle": "Érdeklődési űrlap",
    "generalEnquiry": "Általános érdeklődés",
    "specificProduct": "Ha konkrét termékről szeretne kérdést feltenni, kérjük, lépjen a termék oldalára.",
    "privacyConsent": "Hozzájárulok a személyes adataim feldolgozásához az Adatvédelmi irányelveknek megfelelően *"
  },
  "home": {
    "featuredHomes": {
      "natura": {
        "name": "Natura",
        "description": "Környezetbarát, Modern Kényelem"
      },
      "sensa": {
        "name": "Sensa",
        "description": "Tágas Kilátás, Nyitott Életterek"
      }
    },
    "hero": {
      "title": "Prémium élet, bárhová mész",
      "subtitle": "Fedezze fel prémium mobilházaink és termékeink kínálatát"
    },
    "intro": "Üdvözöljük az MZM Homes-nál, ahol az innovatív tervezés találkozik a fenntartható építkezéssel.",
    "intro2": "Az offsite gyártás erejét kihasználva egyedi moduláris otthonokat és egyéb projekteket szállítunk.",
    "mobileHomes": {
      "title": "Mobilházak",
      "description": "Fedezze fel szakértelemmel készített moduláris otthonaink gyűjteményét, amelyeket kényelemre, stílusra és rugalmasságra terveztek. Bármilyen életstílushoz illeszkedve ezek az otthonok luxus életet kínálnak a szabadsággal, hogy bárhová menjen az élet."
    },
    "otherProducts": {
      "title": "Egyéb termékek",
      "description": "Fedezze fel adaptálható szerkezeteink kínálatát, beleértve garázsokat, kocsibeállókat, konténereket és teraszokat, amelyeket bármely otthon kiegészítésére terveztek. Minden termék ötvözi a tartósságot és a stílust, funkcionális tereket teremtve."
    },
    "featuredProducts": {
      "garages": {
        "name": "Garázsok",
        "description": "Tartós, stílusos megoldások járművei védelmére, miközben növelik ingatlana értékét."
      },
      "carports": {
        "name": "Kocsibeálló",
        "description": "Nyitott járművédelmi megoldások, amelyek ötvözik a tartósságot és a hozzáférhetőséget."
      },
      "containers": {
        "name": "Konténerek",
        "description": "Fedezze fel sokoldalú konténer megoldásainkat, amelyeket tartósságra és végtelen lehetőségekre terveztek."
      },
      "outdoorKitchens": {
        "name": "Kültéri konyhák",
        "description": "Alakítsa át kültéri terét stílusos és funkcionális kültéri konyha megoldásainkkal."
      },
      "garbageBins": {
        "name": "Szemetestartók",
        "description": "Praktikus és stílusos megoldások a hulladékkezeléshez."
      }
    },
    "testimonials": {
      "title": "Vásárlói történetek",
      "description": "Minőség iránti elkötelezettségünk és személyre szabott szolgáltatásunk tartós benyomást keltett. Fedezze fel, hogyan alakították át moduláris otthonaink és szerkezeteink az ő lakótereiket és javították életstílusukat."
    },
    "loading": "Betöltés",
    "enquireNow": "Érdeklődjön most"
  },
  "products": {
    "loading": "Termékek betöltése...",
    "title": "Egyéb termékek",
    "description": "Fedezze fel adaptálható szerkezeteink kínálatát, beleértve garázsokat, kocsibeállókat, konténereket és teraszokat, amelyeket bármely otthon kiegészítésére terveztek. Minden termék ötvözi a tartósságot és a stílust, funkcionális tereket teremtve.",
    "viewAll": "Összes megtekintése",
    "noProducts": "Jelenleg nem állnak rendelkezésre termékek. Kérjük, ellenőrizze később.",
    "categoriesTitle": "Termékkategóriák",
    "categoriesObject": {
      "title": "Termékkategóriák",
      "list": {
        "garagesCarports": {
          "name": "Garázsok és kocsibeállók",
          "description": "Tartós, stílusos megoldások járművei védelmére, miközben növelik ingatlana értékét. Funkcionalitásra és esztétikai vonzerőre tervezve ezek a szerkezetek a biztonság és elegancia tökéletes keverékét kínálják."
        },
        "containers": {
          "name": "Konténerek",
          "description": "Fedezze fel sokoldalú konténer megoldásainkat, amelyeket tartósságra és végtelen lehetőségekre terveztek. Legyen szó tárolásról, szállításról vagy egyedi projektekről, konténereink megbízható, rugalmas opciókat kínálnak egyedi igényeinek kielégítésére."
        },
        "outdoorKitchens": {
          "name": "Kültéri konyhák",
          "description": "Alakítsa át kültéri terét stílusos és funkcionális kültéri konyha megoldásainkkal. Tökéletes vendégek szórakoztatására vagy családi étkezések élvezetére a friss levegőn."
        },
        "garbageBins": {
          "name": "Szemetestartók",
          "description": "Praktikus és stílusos megoldások a hulladékkezeléshez. Szemetestartó burkolataink rendezetté teszik kültéri terét, miközben kiegészítik otthona esztétikáját."
        }
      }
    },
    "details": "Termék részletek",
    "specifications": "Specifikációk",
    "categories": {
      "garages": {
        "name": "Garázsok",
        "description": "Tartós, stílusos megoldások járművei védelmére, miközben növelik ingatlana értékét. Funkcionalitásra és esztétikai vonzerőre tervezve ezek a szerkezetek a biztonság és elegancia tökéletes keverékét kínálják."
      },
      "carports": {
        "name": "Kocsibeálló",
        "description": "Nyitott járművédelmi megoldások, amelyek ötvözik a tartósságot és a hozzáférhetőséget. Kocsibeállóink megbízható menedéket nyújtanak járművei számára, miközben nyitott kialakítást tartanak fenn, amely zökkenőmentesen illeszkedik ingatlanához."
      },
      "containers": {
        "name": "Konténerek",
        "description": "Fedezze fel sokoldalú konténer megoldásainkat, amelyeket tartósságra és végtelen lehetőségekre terveztek. Legyen szó tárolásról, szállításról vagy egyedi projektekről, konténereink megbízható, rugalmas opciókat kínálnak egyedi igényeinek kielégítésére."
      },
      "outdoorKitchens": {
        "name": "Kültéri konyhák",
        "description": "Alakítsa át kültéri terét stílusos és funkcionális kültéri konyha megoldásainkkal. Tökéletes vendégek szórakoztatására vagy családi étkezések élvezetére a friss levegőn."
      },
      "garbageBins": {
        "name": "Szemetestartók",
        "description": "Praktikus és stílusos megoldások a hulladékkezeléshez. Szemetestartó burkolataink rendezetté teszik kültéri terét, miközben kiegészítik otthona esztétikáját."
      }
    },
    "categoryDetails": {
      "garagesCarports": {
        "name": "Garázsok és kocsibeállók",
        "description": "Tartós, stílusos megoldások járművei védelmére, miközben növelik ingatlana értékét. Funkcionalitásra és esztétikai vonzerőre tervezve ezek a szerkezetek a biztonság és elegancia tökéletes keverékét kínálják."
      },
      "containers": {
        "name": "Konténerek",
        "description": "Fedezze fel sokoldalú konténer megoldásainkat, amelyeket tartósságra és végtelen lehetőségekre terveztek. Legyen szó tárolásról, szállításról vagy egyedi projektekről, konténereink megbízható, rugalmas opciókat kínálnak egyedi igényeinek kielégítésére."
      },
      "outdoorKitchens": {
        "name": "Kültéri konyhák",
        "description": "Alakítsa át kültéri terét stílusos és funkcionális kültéri konyha megoldásainkkal. Tökéletes vendégek szórakoztatására vagy családi étkezések élvezetére a friss levegőn."
      },
      "garbageBins": {
        "name": "Szemetestartók",
        "description": "Praktikus és stílusos megoldások a hulladékkezeléshez. Szemetestartó burkolataink rendezetté teszik kültéri terét, miközben kiegészítik otthona esztétikáját."
      }
    },
    "garages": {
      "garage6x3": {
        "name": "Garázs 6x3",
        "description": "Kompakt és funkcionális garázs egy jármű számára"
      },
      "garage6x6": {
        "name": "Garázs 6x6",
        "description": "Tágas garázsmegoldás több jármű számára"
      },
      "garageWithCarport": {
        "name": "Garázs kocsibeállóval",
        "description": "Kombinált megoldás zárt garázzsal és csatlakoztatott kocsibeállóval"
      }
    },
    "carports": {
      "carport6x3": {
        "name": "Kocsibeálló 6x3",
        "description": "Nyitott járművédelem tartós konstrukcióval"
      },
      "carport6x6": {
        "name": "Kocsibeálló 6x6",
        "description": "Tágas nyitott menedék több jármű számára"
      }
    },
    "containers": {
      "basic": {
        "name": "ALAP Konténer",
        "description": "Egyszerű, tartós tárolási megoldás különféle igényekhez"
      },
      "premium": {
        "name": "PRÉMIUM Konténer",
        "description": "Továbbfejlesztett konténer további funkciókkal és kiváló minőséggel"
      }
    },
    "outdoorKitchens": {
      "basic": {
        "name": "BASIC Kültéri konyha",
        "description": "Egyszerű és funkcionális kültéri konyha megoldás"
      },
      "premium": {
        "name": "PRÉMIUM Kültéri konyha",
        "description": "Luxus kültéri konyha prémium funkciókkal"
      }
    },
    "garbageBins": {
      "basic": {
        "name": "BASIC tároló",
        "description": "Egyszerű és funkcionális kuka megoldás"
      },
      "premium": {
        "name": "PRÉMIUM Szemetestartó tároló",
        "description": "Továbbfejlesztett szemetestartó megoldás prémium funkciókkal"
      }
    },
    "items": {
      "garage6x3": {
        "name": "Garázs 6x3",
        "description": "Kompakt és funkcionális garázs egy jármű számára"
      },
      "garage6x6": {
        "name": "Garázs 6x6",
        "description": "Tágas garázsmegoldás több jármű számára"
      },
      "garageWithCarport": {
        "name": "Garázs kocsibeállóval",
        "description": "Kombinált megoldás zárt garázzsal és csatlakoztatott kocsibeállóval"
      },
      "basicContainer": {
        "name": "BASIC Konténer",
        "description": "Egyszerű, tartós tárolási megoldás különféle igényekhez"
      },
      "premiumContainer": {
        "name": "PRÉMIUM Konténer",
        "description": "Továbbfejlesztett konténer további funkciókkal és kiváló minőséggel"
      },
      "basicKitchen": {
        "name": "BASIC Kültéri konyha",
        "description": "Egyszerű és funkcionális kültéri konyha megoldás"
      },
      "premiumKitchen": {
        "name": "PRÉMIUM Kültéri konyha",
        "description": "Luxus kültéri konyha prémium funkciókkal"
      },
      "basicBin": {
        "name": "BASIC Kuka tároló",
        "description": "Egyszerű és funkcionális szemetestartó megoldás"
      },
      "premiumBin": {
        "name": "PREMIUM Kuka tároló",
        "description": "Továbbfejlesztett szemetestartó megoldás prémium funkciókkal"
      }
    }
  },
  "about": {
    "loading": "Rólunk oldal betöltése...",
    "title": "Rólunk",
    "whoWeAre": "Kik vagyunk",
    "jumpTo": "Ugrás ide",
    "meetTheTeam": "Ismerje meg a csapatot",
    "team": "Csapatunk",
    "history": "Történetünk",
    "mission": "Küldetésünk",
    "part1": {
      "title": "Az MZM Homes-t 2024-ben alapították olyan emberek, akik értékelik a tervezést, innovációt és fenntarthatóságot.",
      "description": "Szlovénia egyik vezető offsite építési szakértőjeként több időt töltünk azzal, hogy jobb, okosabb és gyorsabb építési módokat találjunk."
    },
    "part2": {
      "title": "Megközelítésünk a legújabb gyártási technológiát hasznosítja, biztosítva a precizitást, tartósságot és jelentősen csökkentett környezeti lábnyomot.",
      "description": "Emellett támogatjuk a helyi anyagokat és beszállítókat, hogy kivételes, fenntartható szemléletű megoldásokat nyújtsunk."
    },
    "part3": {
      "title": "Minden MZM Homes projekt egy egyedi és bevált megközelítés eredménye, amelyet több mint 100 befejezett otthon és egyéb szerkezet bizonyít.",
      "description": "Kulcsrakész szolgáltatásunk és átlátható árazási modellünk lehetővé teszi a zökkenőmentes átmenetet a tervezőasztaltól az ajtóig, így az út ugyanolyan zökkenőmentes, mint amilyen átalakító."
    }
  },
  "blog": {
    "latestPosts": "Legújabb bejegyzések",
    "readMore": "Tovább",
    "postedOn": "Közzétéve"
  },
  "footer": {
    "salesEnquiries": "Értékesítési érdeklődések",
    "generalEnquiries": "Általános érdeklődések",
    "followUs": "Kövessen minket",
    "office": "MZM Iroda",
    "factory": "MZM Gyár",
    "pages": "Oldalak",
    "products": "Termékek",
    "homePage": "Kezdőlap",
    "garages": "Garázsok",
    "carports": "Kocsibeállók",
    "containers": "Konténerek",
    "kitchens": "Konyhák",
    "garbageBins": "Szemetesek",
    "rights": "Minden jog fenntartva",
    "copyright": "© {year} MZM Homes. Minden jog fenntartva.",
    "sitemap": "Oldaltérkép",
    "privacy": "Adatvédelmi irányelvek",
    "terms": "Szolgáltatási feltételek",
    "cookies": "Cookie szabályzat",
    "social": {
      "instagram": "Instagram",
      "linkedin": "LinkedIn",
      "facebook": "Facebook"
    }
  },
  "homes": {
    "loading": "Otthon modellek betöltése...",
    "gallery": {
      "loading": "Képek betöltése..."
    },
    "title": "Mobilházak",
    "description": "Exkluzív kollekciónk négy szakértelemmel tervezett házmodellt kínál, mindegyik egyedülálló keverékét nyújtva a stílusnak, funkcionalitásnak és kivitelezésnek. Az eco-barát innovációktól a tágas, luxus lakóterekig otthonaink különböző ízlésekhez és életstílusokhoz igazodnak.",
    "error": {
      "title": "Hoppá! Valami hiba történt",
      "message": "Nem találtuk a keresett otthon modelleket.",
      "backButton": "Vissza a főoldalra"
    },
    "naturaLine": {
      "title": "Natura sorozat",
      "description": "Bemutatjuk a Natura sorozatot—ahol a fenntarthatóság találkozik a modern luxussal. Eco-tudatos anyagokkal és energiahatékony funkciókkal tervezve ezek az otthonok tökéletes egyensúlyt kínálnak a stílus, kényelem és környezeti felelősségvállalás között."
    },
    "sensaLine": {
      "title": "Sensa sorozat",
      "description": "Bemutatjuk a Sensa sorozatot—emeli lakóélményét tágas, nyitott tervezéssel és lélegzetelállító kilátásokkal. Ezek az otthonok ötvözik a kortárs eleganciát a funkcionalitással, megteremtve a tökéletes környezetet a modern élethez."
    },
    "noResults": "Nem találtunk otthon modelleket. Kérjük, ellenőrizze később.",
    "specifications": {
      "ceilingHeight": "Mennyezet magassága",
      "windows": "Ablakok",
      "terrace": "Terasz",
      "wallRoofInsulation": "Fal és tető szigetelés",
      "floorInsulation": "Padló szigetelés",
      "energyRating": "Energia besorolás"
    },
    "models": {
      "naturaMini": {
        "name": "Natura Mini",
        "description": "Eco-barát tervezés modern kényelemmel és energiahatékonysággal.",
        "longDescription": "A Natura Mini a zászlóshajónk az eco-barát otthonok terén, amelyet a fenntarthatóság szem előtt tartásával terveztek, anélkül, hogy kompromisszumot kötnénk a kényelemben vagy stílusban. Energiahatékony rendszerekkel, fenntartható anyagokkal és okosotthon technológiával ez a modell a felelősségteljes élet jövőjét képviseli. A nyitott alaprajz tágas érzetet kelt, miközben maximalizálja a természetes fény használatát."
      },
      "naturaMaxi": {
        "name": "Natura Maxi",
        "description": "Bővített eco-barát otthon további hellyel a családok számára.",
        "longDescription": "A Natura Maxi a nagyobb eco-barát otthonunk, amely további helyet kínál a családok számára, miközben megőrzi a fenntarthatóság és minőség iránti elkötelezettséget. Több hálószobával és lakótérrel ez a modell tökéletes azok számára, akiknek extra helyre van szükségük anélkül, hogy kompromisszumot kötnének a környezeti értékekkel."
      },
      "sensaMini": {
        "name": "Sensa Mini",
        "description": "Tágas tervezés nagy ablakokkal a lenyűgöző kilátásért.",
        "longDescription": "A Sensa Mini úgy lett tervezve, hogy maximalizálja a kapcsolatot a környező környezettel tágas ablakaival és nyitott koncepciójú lakótereivel. Tökéletes festői helyszínekre, ez az otthon behozza a kültért, miközben a modern élet minden kényelmét biztosítja. Luxus befejezések és átgondolt tervezési elemek kifinomult, mégis kényelmes atmoszférát teremtenek."
      },
      "sensaMaxi": {
        "name": "Sensa Maxi",
        "description": "Legnagyobb panorámás otthonunk prémium funkciókkal és hellyel.",
        "longDescription": "A Sensa Maxi a legtágasabb modellünk, amely tágas lakótereket és prémium funkciókat kínál. Nagy ablakaival és nyitott tervezésével ez az otthon zökkenőmentes kapcsolatot teremt a kültérrel, miközben minden luxust és kényelmet biztosít, amire vágyhat. Tökéletes azok számára, akik nyilatkozatot szeretnének tenni."
      }
    },
    "features": {
      "energyEfficient": "Energiahatékony tervezés",
      "sustainableMaterials": "Fenntartható anyagok",
      "smartHome": "Okosotthon technológia",
      "openFloorPlan": "Nyitott alaprajz",
      "familySized": "Családi méretű elrendezés",
      "additionalStorage": "További tárolóhely",
      "floorToCeiling": "Padlótól mennyezetig érő ablakok",
      "openConcept": "Nyitott koncepciójú lakótér",
      "luxuryFinishes": "Luxus befejezések",
      "indoorOutdoor": "Beltéri-kültéri áramlás",
      "premiumFinishes": "Prémium befejezések",
      "spaciousMaster": "Tágas fő hálószoba",
      "multipleLiving": "Több lakótér",
      "homeOffice": "Otthoni iroda",
      "designerKitchen": "Tervezői konyha",
      "optionalDeck": "Opcionális fedélzeti kiterjesztések",
      "ledLighting": "LED világítás az egész házban",
      "waterSaving": "Víztakarékos berendezések",
      "insulationEnergy": {
        "insulation": {
          "highQuality": "Kiváló minőségű szigetelés"
        }
      }
    },
    "includedFeatures": {
      "title": "Mi van benne?",
      "headers": {
        "centralSpace": "Központi tér",
        "bathroomBedrooms": "Fürdőszoba és hálószobák",
        "outside": "Kívül"
      },
      "centralSpace": {
        "kitchen": "Konyha indukciós főzőlappal",
        "refrigerator": "Hűtőszekrény",
        "sofa": "Kihúzható kanapé",
        "tv": "LCD TV",
        "table": "Asztal",
        "chairs": "4 szék"
      },
      "bathroomBedrooms": {
        "waterHeater": "Vízmelegítő",
        "bathroom": "Teljes fürdőszoba egység",
        "toilet": "WC",
        "shower": "Zuhanykabin",
        "bedBase": "Latoflex ágyalap",
        "mattress": "Matrac",
        "wardrobe": "Garderób és polcok"
      },
      "outside": {
        "windows": "Panoráma ablakok lenyűgöző kilátással",
        "heatingCable": "Fűtőkábel a kültéri vízcsatlakozáshoz",
        "protection": "Védelem a telepítésekhez",
        "terrace": "Terasz (3x8m) horganyzott profilokból és szendvicspanelekkel borítva",
        "wallRoof": "Fal és tető: 10 cm (W/mK = 0.22)",
        "decorativePanels": "Dekoratív fa panelek horganyzott acéllemezből"
      }
    },
    "details": {
      "bedrooms": "Hálószobák",
      "kitchen": "Konyha",
      "bathrooms": "Fürdőszobák",
      "area": "Terület",
      "terrace": "Terasz",
      "moreSpecifications": "További specifikációk",
      "enquireAbout": "Érdeklődjön erről az otthonról",
      "insulationEnergy": "Szigetelés és energiahatékonyság",
      "insulation": "Szigetelés",
      "energyFeatures": "Energia funkciók",
      "premiumFeatures": "Prémium funkciók",
      "availableAsOption": "Opcióként elérhető",
      "floorPlans": "Alaprajz",
      "floorPlansDescription": "Fedezze fel átgondoltan tervezett alaprajzainkat, amelyek különböző életstílusokhoz igazodnak. Minden elrendezés maximalizálja a teret, kényelmet és funkcionalitást, tökéletes alapot nyújtva álmai otthonához.",
      "otherModels": "Egyéb otthon modellek",
      "otherModelsDescription": "Fedezze fel szakértelemmel készített moduláris otthonaink gyűjteményét, amelyeket kényelemre, stílusra és rugalmasságra terveztek. Bármilyen életstílushoz illeszkedve ezek az otthonok luxus életet kínálnak a szabadsággal, hogy bárhová menjen az élet.",
      "garagesDescription": "Biztonságos tárolás, elegáns tervezés",
      "containersDescription": "Rugalmas, tartós megoldások",
      "homeGardenDescription": "Elegáns élet, kültéri boldogság"
    },
    "insulationEnergy": {
      "insulation": {
        "wallRoof": "Fal és tető: 10cm (W/mK = 0.22)",
        "floor": "Padló: 12cm szigetelés",
        "windows": "Ablakok: Ug = 1.1 W/m²K",
        "doubleGlazed": "Dupla üvegezésű ablakok",
        "thermalBreak": "Hőhídmentes rendszer",
        "highQuality": "Kiváló minőségű szigetelés"
      },
      "energyFeatures": {
        "solarReady": "Napelemre kész",
        "ledLighting": "LED világítás az egész házban",
        "efficientAppliances": "Energiahatékony berendezések"
      }
    },
    "premiumFeatures": {
      "panoramicWindows": "Panoráma ablakok lenyűgöző kilátással",
      "flexibility": "Rugalmasság és mobilitás",
      "qualityMaterials": "Kiváló minőségű anyagok",
      "energyEfficiency": "Energiahatékonyság",
      "aestheticAppeal": "Esztétikai vonzerő",
      "customization": "Testreszabás",
      "fastMoveIn": "Gyors beköltözés",
      "idealRental": "Ideális bérléshez",
      "lowMaintenance": "Alacsony karbantartási költségek",
      "privacy": "Magánélet és nyugalom",
      "compactDesign": "Kompakt és tágas tervezés"
    },
    "genericModel": {
      "name": "Otthon modell",
      "description": "Modern moduláris otthon tervezés.",
      "longDescription": "Ez a modell a kényelem, stílus és funkcionalitás tökéletes egyensúlyát kínálja. A modern életet szem előtt tartva tervezve, nyitott tereket, minőségi anyagokat és energiahatékony megoldásokat kínál.",
      "features": {
        "modernDesign": "Modern dizájn",
        "qualityMaterials": "Minőségi anyagok",
        "energyEfficiency": "Energiahatékonyság",
        "customizableOptions": "Testreszabható opciók"
      }
    }
  },
  "breadcrumb": {
    "home": "Főoldal",
    "mobileHomes": "Mobilházak",
    "products": "Egyéb termékek",
    "about": "Rólunk",
    "contact": "Kapcsolat",
    "blog": "Blog",
    "garages": "Garázsok",
    "containers": "Konténerek",
    "homeGarden": "Otthon és kert"
  },
  "productDetails": {
    "common": {
      "otherProducts": "Egyéb termékek",
      "otherProductsDescription": "Fedezze fel adaptálható szerkezeteink kínálatát, beleértve garázsokat, kocsibeállókat, konténereket és teraszokat, amelyeket bármely otthon kiegészítésére terveztek. Minden termék ötvözi a tartósságot és a stílust, funkcionális tereket teremtve."
    },
    "garages": {
      "loading": "Garázs részletek betöltése...",
      "error": {
        "title": "Hoppá! Valami hiba történt",
        "message": "Nem találtuk a keresett garázst.",
        "backButton": "Vissza a garázsokhoz"
      },
      "dimensions": "Méretek:",
      "area": "Terület:",
      "height": "Magasság:",
      "doorWidth": "Ajtó szélesség:",
      "doorHeight": "Ajtó magasság:",
      "moreSpecifications": "További specifikációk",
      "materials": "Anyagok",
      "qualityMaterials": "Minőségi anyagok",
      "additionalFeatures": "További funkciók",
      "features": "Jellemzők",
      "customizationOptions": "Testreszabási opciók",
      "otherModels": "Egyéb garázs modellek",
      "otherModelsDescription": "Fedezze fel garázsmegoldásaink választékát, amelyeket tartósságra, funkcionalitásra és stílusra terveztek. Minden modell biztonságos tárolást kínál járművei és felszerelései számára.",
      "enquireButton": "Érdeklődés",
      "enquireAbout": "Kérjen ajánlatot erre a garázsra",
      "openGallery": "Galéria megnyitása",
      "price": "Ár:"
    },
    "containers": {
      "loading": "Konténer részletek betöltése...",
      "error": {
        "title": "Hoppá! Valami hiba történt",
        "message": "Nem találtuk a keresett konténert.",
        "backButton": "Vissza a konténerekhez"
      },
      "dimensions": "Méretek:",
      "area": "Terület:",
      "height": "Magasság:",
      "doorWidth": "Ajtó szélesség:",
      "doorHeight": "Ajtó magasság:",
      "moreSpecifications": "További specifikációk",
      "materials": "Anyagok",
      "qualityMaterials": "Minőségi anyagok",
      "additionalFeatures": "További funkciók",
      "features": "Jellemzők",
      "customizationOptions": "Testreszabási opciók",
      "otherModels": "Egyéb konténer modellek",
      "otherModelsDescription": "Fedezze fel konténer megoldásaink választékát, amelyeket sokoldalúságra, tartósságra és funkcionalitásra terveztek. Minden modell rugalmas teret kínál különféle alkalmazásokhoz.",
      "enquireButton": "Érdeklődés",
      "enquireAbout": "Érdeklődjön erről a konténerről",
      "openGallery": "Galéria megnyitása",
      "price": "Ár:"
    },
    "outdoorKitchens": {
      "loading": "Kültéri konyha részletek betöltése...",
      "error": {
        "title": "Hoppá! Valami hiba történt",
        "message": "Nem találtuk a keresett kültéri konyhát.",
        "backButton": "Vissza a kültéri konyhákhoz"
      },
      "dimensions": "Méretek:",
      "area": "Terület:",
      "height": "Magasság:",
      "moreSpecifications": "További specifikációk",
      "materials": "Anyagok",
      "qualityMaterials": "Minőségi anyagok",
      "additionalFeatures": "További funkciók",
      "features": "Jellemzők",
      "customizationOptions": "Testreszabási opciók",
      "otherModels": "Egyéb kültéri konyha modellek",
      "otherModelsDescription": "Fedezze fel kültéri konyha megoldásaink választékát, amelyeket stílusra, funkcionalitásra és tartósságra terveztek. Minden modell tökéletes teret kínál a kültéri főzéshez és szórakoztatáshoz.",
      "enquireButton": "Érdeklődés",
      "enquireAbout": "Érdeklődjön erről a kültéri konyháról",
      "openGallery": "Galéria megnyitása",
      "price": "Ár:"
    },
    "garbageBins": {
      "loading": "Szemetestartó részletek betöltése...",
      "error": {
        "title": "Hoppá! Valami hiba történt",
        "message": "Nem találtuk a keresett szemetestartót.",
        "backButton": "Vissza a szemetestartókhoz"
      },
      "dimensions": "Méretek:",
      "area": "Terület:",
      "height": "Magasság:",
      "moreSpecifications": "További specifikációk",
      "materials": "Anyagok",
      "qualityMaterials": "Minőségi anyagok",
      "additionalFeatures": "További funkciók",
      "features": "Jellemzők",
      "customizationOptions": "Testreszabási opciók",
      "otherModels": "Egyéb szemetestartó modellek",
      "otherModelsDescription": "Fedezze fel szemetestartó megoldásaink választékát, amelyeket praktikusságra, tartósságra és stílusra terveztek. Minden modell hatékony hulladékkezelést kínál, miközben kiegészíti ingatlanát.",
      "enquireButton": "Érdeklődés",
      "enquireAbout": "Érdeklődjön erről a szemetestartóról",
      "openGallery": "Galéria megnyitása",
      "price": "Ár:"
    },
    "enquiryForm": "Érdeklődési űrlap",
    "enquiringAbout": "Érdeklődik erről:",
    "generalEnquiry": "Ha általános érdeklődést szeretne benyújtani, kattintson ide."
  }
}
